// SAB-401: NFL mobile acquisition strip. Mirrors
// mlb-beta/players-mobile/AcquisitionStrip.tsx but:
//   - dropped FAAB display when waiver mode is FCFS (same MLB rule);
//     NFL only surfaces FAAB if league uses non-FCFS waivers
//   - dropped compare-mode (NFL doesn't have a PlayerCompareDialog
//     analogue in v1 — defer to a separate ticket if Adam wants it)
//   - dropped maxAcquisitions meter: NFL leagues don't enforce a weekly
//     transactions cap in v1; the desktop NFLPlayersPage doesn't show one
//     either. Just shows FAAB on non-FCFS leagues.
import { DollarSign } from 'lucide-react';

type WaiverMode = 'fcfs' | 'faab' | 'priority' | 'weekly' | string;

interface AcquisitionStripProps {
  faabRemaining: number;
  waiverMode: WaiverMode;
}

export function AcquisitionStrip({
  faabRemaining, waiverMode,
}: AcquisitionStripProps) {
  // FCFS leagues don't use FAAB, so don't surface it (matches MLB pattern).
  const showFaab = waiverMode !== 'fcfs';
  if (!showFaab) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2 text-[12px]">
      <div className="flex items-center gap-1 shrink-0 text-gold">
        <DollarSign className="w-3.5 h-3.5" />
        <span className="font-display font-semibold tabular-nums">
          {faabRemaining} FAAB
        </span>
      </div>
    </div>
  );
}

export default AcquisitionStrip;
